import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AnimatedCol from "../../../../components/AnimatedCol";
import { setCalculateDesignLoadCheckbox } from "../../../../store/slices/aashtoSlice";

export function FdCalc() {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const calculatedDesignLoadCheckbox = useSelector(
    (state) => state.aashto.frontendState.calculatedDesignLoadCheckbox
  );

  return (
    <AnimatedCol>
      <div className="verticallyAligned">
        <input
          type="checkbox"
          checked={calculatedDesignLoadCheckbox}
          onChange={(e) => {
            dispatch(setCalculateDesignLoadCheckbox(e.target.checked));
          }}
        />
        <label>
          <Trans
            i18nKey="aashto.inner.Pd Calculation"
            values={{ pd: "P<sub>d</sub>" }}
            components={{ sub: <sub /> }}
          />
        </label>
      </div>
    </AnimatedCol>
  );
}
